"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toKebabCase = require("@insided/shared/utils/toKebabCase");

var id = 0;

var idGenerator = function idGenerator(text) {
  id++;
  return "".concat((0, _toKebabCase.textToKebab)(text), "-").concat(id);
};

var _default = idGenerator;
exports.default = _default;